import $ from 'jquery';
import { Litepicker } from 'litepicker';
import 'litepicker/dist/plugins/mobilefriendly';
import dateFormat from 'date-fns/format';

function getLitepickerMinDate() {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const day = today.getDate();
  return `${year}-${month}-${day}`;
}

$('.js-booking').each((index, booking) => {
  const $booking = $(booking);
  const $bookingCheckin = $booking.find('.js-booking-checkin');
  const $bookingCheckout = $booking.find('.js-booking-checkout');
  const $bookingGuests = $booking.find('.js-booking-guests');
  const $bookingAdults = $booking.find('.js-booking-adults');
  const $bookingChildren = $booking.find('.js-booking-children');
  const $bookingDatepicker = $booking.find('.js-booking-datepicker');

  new ResizeObserver(() => {
    $booking.css({
      '--booking-width': `${$booking.outerWidth()}px`,
    });
  }).observe($booking[0]);

  console.log('ye');

  const litepicker = new Litepicker({
    buttonText: {
      previousMonth: `<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 86.9 44.7" xml:space="preserve"><path d="M84.8 20.3H7.1L23.8 3.6c.8-.8.8-2.1 0-2.9-.8-.8-2.1-.8-2.9 0L.6 20.9c-.2.2-.3.4-.4.6 0 .1-.1.1-.1.2-.2.5-.1.9 0 1.4v.1c.1.2.2.4.4.6v.1l20.3 20.3c.8.8 2.1.8 2.9 0 .8-.8.8-2.1 0-2.9L7.1 24.4h77.7c1.2 0 2.1-.9 2.1-2.1 0-1.1-.9-2-2.1-2"/></svg>`,
      nextMonth: `<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 86.9 44.7" xml:space="preserve"><path d="M2.1 24.4h77.7L63.1 41.2c-.8.8-.8 2.1 0 2.9.8.8 2.1.8 2.9 0l20.3-20.3c.2-.2.3-.4.4-.6 0-.1.1-.1.1-.2.2-.5.1-.9 0-1.4v-.1c-.1-.2-.2-.4-.4-.6v-.1L66 .6c-.8-.8-2.1-.8-2.9 0-.8.8-.8 2.1 0 2.9l16.7 16.7H2.1c-1.2 0-2.1.9-2.1 2.1 0 1.2.9 2.1 2.1 2.1"/></svg>`,
    },
    disallowLockDaysInRange: true,
    element: $bookingDatepicker[0],
    firstDay: 0,
    format: 'MMM D, YYYY',
    minDate: getLitepickerMinDate(),
    numberOfColumns: 1,
    numberOfMonths: 1,
    parentEl: $bookingDatepicker.parent()[0],
    // plugins: ['mobilefriendly'],
    selectForward: true,
    showTooltip: false,
    singleMode: false,
  });

  litepicker.on('selected', (dateCheckin, dateCheckout) => {
    $bookingCheckin.val(dateFormat(dateCheckin.dateInstance, `yyyy-MM-dd`));
    $bookingCheckout.val(dateFormat(dateCheckout.dateInstance, `yyyy-MM-dd`));
  });

  function updateBookingGuests() {
    const guests = [];
    const adults = Number($bookingAdults.val());
    const children = Number($bookingChildren.val());

    if (adults === 1) {
      guests.push(`1 Adult`);
    }

    if (adults >= 2) {
      guests.push(`${adults} Adults`);
    }

    if (children === 1) {
      guests.push(`1 Child`);
    }

    if (children >= 2) {
      guests.push(`${children} Children`);
    }

    if (guests.length <= 0) {
      guests.push(`0 Adults`);
    }

    $bookingGuests.val(guests.join(', '));
  }

  $bookingAdults.on('change', updateBookingGuests);
  $bookingChildren.on('change', updateBookingGuests);
});
